import React, { useContext } from "react";

import isTouchDevice from "../SE-Component/Tooltip";
import embLabels from "../../config/emb-labels-en.json";
import { InformationPageContext } from "../CustomHooks/ContextApi";
import Tooltip from "../../utils/Tooltip";
import { getProjectTypeValue } from "../../utils/project";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";

const MicrogridType = ({ isDisabled }) => {
  const { projectType, informationToolTIP, handleProjectTypeChange , projectTypeValue} =
    useContext(InformationPageContext);
    
  return (
    <>
      <div className="row">
        <div className="col-md-12 mt-1">
          <span className="labelCircle mr-2 ">1</span>{" "}
          <span>Select your project type</span>
          <Tooltip
            position="right"
            iconColor="secondary"
            iconSize="small"
            information={informationToolTIP?.selectProjectTypeToolTipData}
          />        
        </div>
      </div>
      <div className="row is-flex mt-2">
        <div className="col-md-4" style={isDisabled ? { display: "none" } : {}}>
          <div
            className={`col-md-12 ${
              projectType === embLabels.STANDARD_MICROGRID 
                ? "border-green-radius-5px"
                : "border-radius-5px"
            }`}
          >
            <div className="row align-items-center">
              <div className="col-md-2">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                  <div className="custom-control custom-radio">
                    <input
                     data-help-id={"design_your_own_icrogrid"}
                      type="radio"
                      id="design_your_own_icrogrid"
                      name="projectType"
                      className="custom-control-input islandableRadio asCompatible"
                      value={projectType === "GREENSTRUXURE_MICROGRID"?"GREENSTRUXURE_MICROGRID":"STANDARD_MICROGRID"}
                      checked={
                       
                        [embLabels.STANDARD_MICROGRID,"GREENSTRUXURE_MICROGRID","STANDARD_MICROGRID"].includes(projectType)
                          ? true
                          : false
                      }
                      onChange={handleProjectTypeChange}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="design_your_own_icrogrid"
                    >
                      &zwnj;
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-10 p-2">
                <div className="row">
                  <div className="col-md-12 mt-1">
                    <span className="bold" ><label htmlFor={"design_your_own_icrogrid"}  className="m-0">Design your own Microgrid</label></span>
                  </div>
                  <div className="col-md-12 mt-1">
                    <span><label htmlFor={"design_your_own_icrogrid"}  className="m-0">"{informationToolTIP?.standardToolTipData}"</label></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
     { (["MGaaS ETO","NMGaaS ETO", "MGaaS AccessToEnergy"].includes(projectTypeValue))  && <div className="col-md-4" >
          <div
            className={`col-md-12 ${
              projectType === embLabels.PACKAGED_MICROGRID
                ? "border-green-radius-5px"
                : "border-radius-5px"
            }`}
          > 
            <div className="row align-items-center">
              <div className="col-md-2 mt-3">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                  <div className="custom-control custom-radio">
                    <input
                       data-help-id =  {"design_your_own_microgrid"}
                      type="radio"
                      id="customRadio2"
                      name="projectType"
                      className="custom-control-input islandableRadio asCompatible"
                      value="PACKAGED_MICROGRID"
                      checked={
                        projectType === embLabels.PACKAGED_MICROGRID
                          ? true
                          : false
                      }
                      onChange={handleProjectTypeChange}
                    />
                    <label
                    data-help-id =  {"design_your_own_microgrid"}
                      className="custom-control-label"
                      htmlFor="customRadio2"
                    >
                      &zwnj;
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-10 p-2">
                <div className="row">
                  <div className="col-md-12 mt-1">
                    <span className="bold">Use pre-configured solutions</span>
                  </div>
                  <div className="col-md-12 mt-1">
                    <span>"{informationToolTIP?.packagedToolTipData}"</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      </div>
    </>
  );
};

export default MicrogridType;
